export default "__VITE_ASSET__nNLSFRcC__"